import { memo } from "react";
import Skeleton from "../../components/Skeleton";

function LabelRow({ children }) {
    return (
        <div className="flex flex-wrap mb-3 md:mb-4">
            <div className="w-full md:w-1/6 mt-1 mb-2 md:mb-1">
                <Skeleton width={60} height={14} />
            </div>
            <div className="w-full md:w-5/6">{children}</div>
        </div>
    );
}

function ChipRow({ count = 8, chipWidth = 36 }) {
    return (
        <div className="flex flex-wrap gap-2">
            {Array.from({ length: count }).map((_, i) => (
                <Skeleton key={i} width={chipWidth} height={30} />
            ))}
        </div>
    );
}

function SliderRow() {
    return (
        <div className="w-[95%] mb-5">
            <Skeleton height={6} className="mb-3" />
            <div className="flex justify-between gap-5 mt-1">
                <Skeleton width={96} height={25} />
                <Skeleton width={96} height={25} />
            </div>
        </div>
    );
}

function FilterSkeleton() {
    return (
        <div className="w-full px-4">
            {/* Header */}
            <div className="flex justify-between items-center border-b pb-2 mb-4">
                <Skeleton width={120} height={28} />
                <Skeleton width={80} height={20} />
            </div>

            <div className="flex flex-wrap items-start">
                {/* Left column */}
                <div className="w-full md:w-1/2">
                    {/* Shape row - icon grid */}
                    <LabelRow>
                        <div className="flex flex-wrap items-center gap-2">
                            {Array.from({ length: 8 }).map((_, i) => (
                                <Skeleton key={i} width={40} height={40} />
                            ))}
                        </div>
                    </LabelRow>
                    {/* Price slider */}
                    <LabelRow>
                        <SliderRow />
                    </LabelRow>
                    {/* Carat slider */}
                    <LabelRow>
                        <SliderRow />
                    </LabelRow>
                </div>

                {/* Right column */}
                <div className="w-full md:w-1/2">
                    {/* Color chips */}
                    <LabelRow>
                        <ChipRow count={13} chipWidth={36} />
                    </LabelRow>
                    {/* Clarity chips */}
                    <LabelRow>
                        <ChipRow count={10} chipWidth={56} />
                    </LabelRow>
                    {/* Cut chips */}
                    <LabelRow>
                        <ChipRow count={5} chipWidth={56} />
                    </LabelRow>
                </div>
            </div>

            {/* Apply button */}
            <div className="text-center my-4">
                <Skeleton width={120} height={38} style={{ display: "inline-block" }} />
            </div>
        </div>
    );
}

export default memo(FilterSkeleton);
